<h1 mat-dialog-title>

    <b>Pagar Cuota Convenio</b></h1>
<br/>
<form #pagoConvenioForm=ngForm>

    <dialog-content>
        <p>
            <form-field appearance="outline" class="mat-input">
                <mat-label> Solicitante </mat-label>

                <mat-option>{{data.rutUsuario}} {{data.nombreUsuario}} {{data.apellidoUsuario}}</mat-option>

            </form-field>
        </p>
        <p>
            <form-field appearance="outline" class="mat-input">
                <mat-label> Monto Solicitado </mat-label>

                <mat-option> {{data.montoSolicitado}} </mat-option>

            </form-field>
        </p>
        <p>
            <form-field appearance="outline" class="mat-input">
                <mat-label> Tipo Convenio </mat-label>
                <mat-option> {{data.tipoConvenioString}} </mat-option>

            </form-field>
        </p>
        <p>
            <form-field appearance="outline" class="mat-input">
                <mat-label> Región </mat-label>
                <mat-option> {{data.regionConvenio}} </mat-option>

            </form-field>
        </p>
        <p>
            <form-field appearance="outline" class="mat-input">
                <mat-label> Proveedor </mat-label>
                <mat-option> {{data.nombreProveedor}} </mat-option>

            </form-field>
        </p>
        <p>
            <form-field appearance="outline" class="mat-input">
                <mat-label> Cantidad Cuotas </mat-label>
                <mat-option> {{data.cantidadCuota}} </mat-option>

            </form-field>
        </p>
        <p>
            <form-field appearance="outline" class="mat-input">
                <mat-label> Número Cuota </mat-label>
                <mat-option> {{data.numCuota}} </mat-option>

            </form-field>
        </p>
        <p>
            <form-field appearance="outline" class="mat-input">
                <mat-label> Cuota a pagar </mat-label>
                <mat-option> {{data.montoSolicitado/data.cantidadCuota}} </mat-option>

            </form-field>
        </p>

        <p *ngIf="data.editable == true">
            <form-field appearance="outline" class="mat-input">
                <mat-label> Adjuntar Comprobante Pago</mat-label>
                <div class="col-lg-6">
                    <input #archivo [(ngModel)]="pagoConvenio.archivoTest" type="file" class="form-control-file" name="archivo" (change)="seleccionaArchivo($event,1)" required accept="application/pdf, image/jpeg, image/jpg, image/png">
                </div>

            </form-field>

        </p>
    </dialog-content>
</form>
<br/>
<mat-dialog-actions>
    <div>
        <button mat-button class="mat-raised-button btn-success" *ngIf="data.editable == true" (click)="onAgregarPagoClick(pagoConvenioForm)">
            <i class ="fa fa-check"> </i> Aceptar
        </button>

        <button mat-button class="mat-raised-button btn-dark" (click)="onCancelarClick()">
            <i class = "fa fa-trash"> </i> Salir
        </button>
    </div>
</mat-dialog-actions>

<br/>